import { render } from "./MyProfilePage.vue?vue&type=template&id=69db9922&scoped=true"
import script from "./MyProfilePage.vue?vue&type=script&lang=js"
export * from "./MyProfilePage.vue?vue&type=script&lang=js"

import "./MyProfilePage.vue?vue&type=style&index=0&id=69db9922&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69db9922"]])

export default __exports__